export default "__VITE_ASSET__xz0XupZn__"